import React, { ChangeEvent, useState, useEffect } from 'react';
import { FormControl, FormLabel, RadioGroup, Radio, Box } from '@mui/material';
import { RadioOption } from '../../../../../components/radio-group';
import { GuardianTypeValue } from './utils';

interface IGuardianTypeComponentProps {
  guardianType?: GuardianTypeValue;
  hasGuardian?: boolean;
  isReadOnly: boolean;
  onGuardianTypeChange: (name: string, value?: GuardianTypeValue) => void;
}

export function GuardianTypeComponent(props: IGuardianTypeComponentProps) {
  const { guardianType, onGuardianTypeChange, hasGuardian, isReadOnly } = props;

  const [isActive, setIsActive] = useState<GuardianTypeValue>('none');

  useEffect(() => {
    if (hasGuardian === false || guardianType === undefined) {
      setIsActive('none');
      onGuardianTypeChange('guardianType', undefined);
      return;
    }
    setIsActive(guardianType);
  }, [guardianType, hasGuardian, onGuardianTypeChange]);

  function handleGuardianTypeChange(_: ChangeEvent<HTMLInputElement>, value: string) {
    const typedValue = value as GuardianTypeValue;
    setIsActive(typedValue);
    onGuardianTypeChange('guardianType', typedValue);
  }

  return hasGuardian ? (
    <FormControl component="fieldset" sx={{ paddingLeft: 1.7 }}>
      <FormLabel id="guardianType-radios" component="legend">
        Type af værge
      </FormLabel>

      {!isReadOnly ? (
        <RadioGroup aria-labelledby="guardianType-radios" name="guardianType" value={isActive} onChange={handleGuardianTypeChange}>
          <RadioOption value="guardianship" control={<Radio />} label="Værgemål (Værgemålsloven § 5)" />
          <RadioOption value="guardianshipWithRevokedLegalCapacity" control={<Radio />} label="Værgemål med frataget retslig handleevne (Værgemålsloven § 6)" />
          <RadioOption value="jointGuardianship" control={<Radio />} label="Samværgemål (Værgemålsloven § 7)" />
        </RadioGroup>
      ) : (
        <Box sx={{ fontSize: '0.875em' }}>{getGuardianTypeDisplay(isActive)}</Box>
      )}
    </FormControl>
  ) : (
    <span />
  );
}

function getGuardianTypeDisplay(value: GuardianTypeValue) {
  switch (value) {
    case 'guardianship':
      return 'Værgemål (Værgemålsloven § 5)';
    case 'guardianshipWithRevokedLegalCapacity':
      return 'Værgemål med frataget retslig handleevne (Værgemålsloven § 6)';
    case 'jointGuardianship':
      return 'Samværgemål (Værgemålsloven § 7)';
    case 'none':
      return 'Ikke valgt';
    default:
      return 'Ikke valgt';
  }
}
